(() => {
    if (window.__khSizeGuideControlsInstalled) return;
    window.__khSizeGuideControlsInstalled = true;

    const storageKey = 'konhill-size-guide-unit-state';

    const readSavedUnit = () => {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      } catch (error) {
        return null;
      }
    };

    const saveUnit = (value) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(value));
      } catch (error) {
        // The guide still works when storage is blocked by the browser.
      }
    };

    const restoreCheckboxUnit = (root) => {
      const saved = readSavedUnit();
      if (!saved || saved.type !== 'checkbox') return;

      root.querySelectorAll(".size-guide-chart-scroll input[type='checkbox']").forEach((input) => {
        if (input.checked === Boolean(saved.checked)) return;

        input.checked = Boolean(saved.checked);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    const restoreButtonUnit = (root) => {
      const saved = readSavedUnit();
      if (!saved || saved.type !== 'button' || !saved.value) return;

      root.querySelectorAll('.size-guide-chart-scroll button').forEach((button) => {
        const value = button.textContent.trim().toUpperCase();
        if (value !== saved.value) return;

        const active =
          button.classList.contains('active') ||
          button.classList.contains('selected') ||
          button.getAttribute('aria-pressed') === 'true' ||
          button.dataset.active === 'true';

        if (!active && button.dataset.khRestoredUnit !== saved.value) {
          button.dataset.khRestoredUnit = saved.value;
          button.click();
        }
      });
    };

    const restoreUnit = (root = document) => {
      restoreCheckboxUnit(root);
      restoreButtonUnit(root);
    };

    const installAxisLock = (scroller) => {
      if (scroller.dataset.axisLockReady === 'true') return;
      scroller.dataset.axisLockReady = 'true';

      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let axis = '';

      scroller.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) return;
          const touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          startScrollLeft = scroller.scrollLeft;
          axis = '';
        },
        { passive: true }
      );

      scroller.addEventListener(
        'touchmove',
        (event) => {
          if (event.touches.length !== 1) return;
          const touch = event.touches[0];
          const deltaX = touch.clientX - startX;
          const deltaY = touch.clientY - startY;

          if (!axis && Math.max(Math.abs(deltaX), Math.abs(deltaY)) > 7) {
            axis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
          }

          if (axis === 'x') {
            event.preventDefault();
            scroller.scrollLeft = startScrollLeft - deltaX;
          }
        },
        { passive: false }
      );

      scroller.addEventListener('touchend', () => {
        axis = '';
      }, { passive: true });
    };

    const initialize = (root = document) => {
      root.querySelectorAll?.('[data-size-guide-chart-scroll]').forEach(installAxisLock);
      restoreUnit(root);
    };

    document.addEventListener(
      'change',
      (event) => {
        if (!event.isTrusted) return;
        const input = event.target.closest?.(".size-guide-chart-scroll input[type='checkbox']");
        if (!input) return;
        saveUnit({ type: 'checkbox', checked: input.checked });
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        if (!event.isTrusted) return;
        const button = event.target.closest?.('.size-guide-chart-scroll button');
        if (!button) return;

        const value = button.textContent.trim().toUpperCase();
        if (value === 'MM' || value === 'CM' || value === 'INCH' || value === 'IN') {
          saveUnit({ type: 'button', value });
        }
      },
      true
    );

    const modalObservers = new WeakMap();
    const watchModal = (modal) => {
      let state = modalObservers.get(modal);
      if (!state) {
        state = { frame: 0, observer: null };
        state.observer = new MutationObserver(() => {
          if (state.frame) return;
          state.frame = window.requestAnimationFrame(() => {
            state.frame = 0;
            if (modal.isConnected && modal.matches(':popover-open')) initialize(modal);
          });
        });
        modalObservers.set(modal, state);
      }
      state.observer.observe(modal, { childList: true, subtree: true });
      initialize(modal);
    };
    document.addEventListener('toggle', (event) => {
      const modal = event.target;
      if (!modal.matches?.('.size-guide-modal')) return;
      if (modal.matches(':popover-open')) {
        watchModal(modal);
      } else {
        const state = modalObservers.get(modal);
        state?.observer.disconnect();
        if (state?.frame) {
          window.cancelAnimationFrame(state.frame);
          state.frame = 0;
        }
      }
    }, true);
  })();

